import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const updateTimelineService = async (
  projectId,
  timelineId,
  { name, startDate, endDate }
) => {
  const host = process.env.REACT_APP_WORK_CALENDAR_API_URL;
  const apiPath = `timelines/project/${projectId}/timeline/${timelineId}/update`;
  const request = {
    url: `https://${host}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    method: 'POST',
    host: host,
    path: apiPath,
    body: JSON.stringify({
      name,
      startDate,
      endDate,
    }),
    data: { name, startDate, endDate },
    headers: {
      'Content-Type': 'application/json',
    },
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);
  const response = await axios(signedRequest);
  return response.data;
};
